// export const API = "https://stagingapi.myclnqhealth.com/api/v1/"; // stage
// export const API = "https://testapi.e-healthmyclnq.com/api/v1/"; //test
export const API = "https://backend.myclnq.co/api/v1/"; //production
// export const API = "http://localhost:4000/api/v1/"; // Network

// export const BaseUrl = "https://stagingapi.myclnqhealth.com"; // stage BaseUrl
// export const BaseUrl = "https://testapi.e-healthmyclnq.com"; //test BaseUrl
export const BaseUrl = "https://backend.myclnq.co"; //production BaseUrl
// export const BaseUrl = "http://localhost:4000/"; // Network BaseUrl

const api = {
  API_ENDPOINT: API,
  BASE_URL: BaseUrl,
};
export default api;
